const FALLBACK_VIEW_START_TIME = '08:00'
const FALLBACK_VIEW_END_TIME = '13:00'

const normalizeTime = value => {
  if (!/^(?:[0-9]|[01]\d|2[0-3]):[0-5]\d$/.test(value)) return null

  const [hours, minutes] = value.split(':')
  return `${hours.padStart(2, '0')}:${minutes}`
}

export default function calendarViewHours(organizationConfig = {}) {
  const calendar = organizationConfig.calendar || {}
  const viewStartTime = normalizeTime(calendar.viewStartTime) || FALLBACK_VIEW_START_TIME
  const viewEndTime = normalizeTime(calendar.viewEndTime) || FALLBACK_VIEW_END_TIME

  return {
    min: `${viewStartTime}:00`,
    max: `${viewEndTime}:00`,
  }
}
